import * as actionTypes from '../actions/actionTypes';
import { updateObject } from '../../utils/updateObject';
import { Reducer } from 'redux';

interface IBackup {
  tenant: string
  name: string
  size: number
  key: string
  fileType: string
  createdAt: string
  createdBy: {
    _id: string
    name: string
  },
  ingested: boolean
  ingestedAt: string
  ingestedBy: string
  url: string
  _id: string
}

export interface IBackupsState {
  backups: { count: number, rows: Array<IBackup> }
  backupsFilter: any
  backup: IBackup
  loading: boolean
  filters: {}
}

const initialState: IBackupsState = {
  backups: { count: 0, rows: [] },
  backupsFilter: {},
  backup: {} as IBackup,
  loading: false,
  filters: {
  },
};

const requestBackupsStart = (state: IBackupsState, action: any): IBackupsState => {
  return updateObject(state, { loading: true });
};

const setBackupsFilter = (state: IBackupsState, action: any) => {
  return updateObject(state, {
    backupsFilter: action.backupsFilter,
  });
};

const fetchBackupsSuccess = (state: IBackupsState, action: any) => {
  return updateObject(state, {
    backups: action.backups,
    loading: false
  });
};

const requestBackupsFail = (state: IBackupsState, action: any) => {
  return updateObject(state, { loading: false });
};


const updateBackupsSuccess = (state: IBackupsState, action: any) => {
  return updateObject(state, { loading: false });
}

// selected filters
const filterBackupsClear = (state: IBackupsState, action: any): IBackupsState => {
  return updateObject(state, { filters: { filteredPlaces: [], filteredGroups: [], filteredAreas: [], filteredModels: [], filteredCompanies: [] } });
}

const reducer: Reducer<IBackupsState> = (state = initialState, action: any) => {
  switch (action.type) {
    case actionTypes.REQUEST_BACKUPS_START: return requestBackupsStart(state, action);
    case actionTypes.FETCH_BACKUPS_SUCCESS: return fetchBackupsSuccess(state, action);
    case actionTypes.REQUEST_BACKUPS_FAIL: return requestBackupsFail(state, action);
    case actionTypes.UPDATE_BACKUPS_SUCCESS: return updateBackupsSuccess(state, action);
    case actionTypes.SET_BACKUPS_FILTER: return setBackupsFilter(state, action);
    case actionTypes.FILTER_BACKUP_CLEAR: return filterBackupsClear(state, action);
    default: return state;
  }
};

export default reducer;
